import { render, staticRenderFns } from "./PortraitCrowd.vue?vue&type=template&id=4011980e&scoped=true"
import script from "./PortraitCrowd.vue?vue&type=script&lang=js"
export * from "./PortraitCrowd.vue?vue&type=script&lang=js"
import style0 from "./PortraitCrowd.vue?vue&type=style&index=0&id=4011980e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4011980e",
  null
  
)

export default component.exports